import React from 'react';
import { connect } from 'react-redux';

import { makeGetSectionTitleSelector } from '../../../../../redux/sections/selectors';
import { FormattedMessage } from 'react-intl';

// TODO: Skeleton instead of Loading...
const ConnectedSectionTitle = ({ title, projectId }) => {
  if (!projectId) {
    return null;
  }

  return !title ? <>Loading...</> : (
    <FormattedMessage id={`${title}`.replaceAll(' ', '_').toUpperCase()} defaultMessage={title || ''} />
  );
}

const makeMapStateToProps = () => {
  const getSectionTitleSelector = makeGetSectionTitleSelector();
  return (state, props) => ({
    title: getSectionTitleSelector(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedSectionTitle);
